export default "__VITE_ASSET__56070e50__"